import React, { useState } from 'react';
import { Card, Typography, Button, Input } from 'antd';
import PreventScoreToggles from './PreventScoreToggles';

const { Title, Text } = Typography;

const PreventScoreToggleTest = () => {
  const [currentValues, setCurrentValues] = useState(null);
  const [testPatientId, setTestPatientId] = useState('');

  const handleToggleChange = (updatedValues) => {
    console.log('Toggle values changed:', updatedValues);
    setCurrentValues(updatedValues);
  };

  return (
    <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
      <Card title="PREVENT Score Toggle Test">
        <div style={{ marginBottom: '16px' }}>
          <Text strong>Enter Patient ID:</Text>
          <Input
            placeholder="Enter patient ID to test"
            value={testPatientId}
            onChange={(e) => setTestPatientId(e.target.value)}
            style={{ marginTop: '8px' }}
          />
        </div>

        {testPatientId && (
          <PreventScoreToggles
            patientId={testPatientId}
            onToggleChange={handleToggleChange}
          />
        )}
        
        <div style={{ marginTop: '24px', padding: '16px', background: '#f5f5f5', borderRadius: '6px' }}>
          <Text strong>Current Toggle Values:</Text>
          <pre style={{ marginTop: '8px', fontSize: '12px' }}>
            {JSON.stringify(currentValues, null, 2)}
          </pre>
        </div>
        
        <Button 
          type="primary" 
          style={{ marginTop: '16px' }}
          onClick={() => window.location.reload()}
        >
          Refresh Page to Test Persistence
        </Button>
      </Card>
    </div>
  );
};

export default PreventScoreToggleTest;
